import "./styles/jobsdaheim.css"

import { startApp, removeModulePrefix } from "~/startApp"
import Layout from '~/components/jobsdaheim/Layout.vue'
import i18n from '~/utils/i18n'

const defaultModules = removeModulePrefix(import.meta.glob(`../pages/default/**/*.vue`))
const siteModules = removeModulePrefix(import.meta.glob(`../pages/jobsdaheim/**/*.vue`))

const modules = {
  ...defaultModules,
  ...siteModules,
}
startApp(modules, Layout, i18n)

